module.exports = __webpack_public_path__ + "img/Terraform-3.1b1c396d.png";